var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconKlarna = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 56,
  height: 24,
  viewBox: "0 0 56 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "#fff",
  width: 56,
  height: 24,
  rx: 4
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.135 6.673)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31.3,0h-2.35a6.015,6.015,0,0,1-2.424,4.848l-.927.7,3.6,4.911h2.961l-3.32-4.521A8.309,8.309,0,0,0,31.3,0Z",
  transform: "translate(-22.902)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.403,
  height: 10.454
}), /*#__PURE__*/React.createElement("rect", {
  width: 2.266,
  height: 10.454,
  transform: "translate(9.959)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M267.384,28.7a2.621,2.621,0,0,0-2.234,1.012V28.9H263v7.23h2.182V32.336A1.523,1.523,0,0,1,266.8,30.7c.948,0,1.5.569,1.5,1.623V36.14h2.16V31.535A2.865,2.865,0,0,0,267.384,28.7Z",
  transform: "translate(-235.283 -25.675)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.365,28.9v.464a3.763,3.763,0,0,0-2.15-.664,3.815,3.815,0,0,0,0,7.63,3.763,3.763,0,0,0,2.15-.664v.464h2.16V28.9Zm-1.971,5.47a1.858,1.858,0,1,1,1.96-1.855A1.909,1.909,0,0,1,128.394,34.37Z",
  transform: "translate(-111.29 -25.675)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M214.513,31.538V30.6H212.3v7.23h2.224V34.457c0-1.138,1.233-1.749,2.087-1.749h.021V30.6A2.714,2.714,0,0,0,214.513,31.538Z",
  transform: "translate(-189.926 -27.375)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M346.965,28.9v.464a3.763,3.763,0,0,0-2.15-.664,3.815,3.815,0,0,0,0,7.63,3.763,3.763,0,0,0,2.15-.664v.464h2.16V28.9Zm-1.971,5.47a1.858,1.858,0,1,1,1.96-1.855A1.909,1.909,0,0,1,344.994,34.37Z",
  transform: "translate(-305.063 -25.675)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(45.001 3.035)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M430.69,31.169A.167.167,0,0,0,430.5,31h-.2v.548h.095v-.2h.105l.084.2h.105l-.095-.221A.163.163,0,0,0,430.69,31.169Zm-.19.084h-.105v-.169h.105c.063,0,.095.032.095.084S430.574,31.253,430.5,31.253Z",
  transform: "translate(-429.952 -30.768)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M427.516,28.8a.517.517,0,0,0-.516.516.524.524,0,0,0,.516.516.516.516,0,0,0,0-1.033Zm0,.938a.414.414,0,0,1-.411-.422.421.421,0,0,1,.411-.422.414.414,0,0,1,.411.422A.421.421,0,0,1,427.516,29.738Z",
  transform: "translate(-427 -28.8)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M428.46,74.9a1.36,1.36,0,1,0,1.359,1.359A1.363,1.363,0,0,0,428.46,74.9Z",
  transform: "translate(-382.089 -67.006)"
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconKlarna, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-Klarna.5264d45e.svg";
export { ForwardRef as ReactComponent };